<template>
  <div class="tva-paragraph-component tva-row" :id="`section-${slug(content.title)}`">
    <h4
      v-if="content.title"
      class="paragraph-title tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-3"
    >{{content.title}}</h4>
    <h6
      v-if="content.small_title"
      class="paragraph-small-title tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-3"
      v-html="content.small_title"
    >{{content.small_title}}</h6>
    <p
      v-if="content.title || content.small_title"
      class="paragraph tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-0 tva-col-md-7"
      v-html="content.text"
    >{{content.text}}</p>
    <p
      v-if="!content.title  && !content.small_title"
      class="paragraph tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-4 tva-col-md-7"
      v-html="content.text"
    >{{content.text}}</p>
  </div>
</template>
<script>
import slugify from "slugify";
export default {
  props: ["content"],
  methods: {
    slug(string) {
      if (string) {
        return slugify(string, {
          lower: true,
          remove: "'"
        });
      } else {
        return "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-paragraph-component {
  .paragraph-title {
    padding: 0;
  }
}
@media (max-width: 1024px) {
  .tva-paragraph-component {
    display: flex;
    flex-direction: column;
    .paragraph {
      padding: 0;
    }
    .paragraph-title,
    .paragraph-small-title {
      padding: 0;
      margin-bottom: 20px;
    }
  }
}
@media (max-width: 1024px) {
  .tva-paragraph-component {
    .paragraph-title,
    .paragraph-small-title {
      margin-top: 20px;
    }
  }
}
</style>


